import { render } from "./DataIsian.vue?vue&type=template&id=098c31e4"
import script from "./DataIsian.vue?vue&type=script&lang=js"
export * from "./DataIsian.vue?vue&type=script&lang=js"

import "./DataIsian.vue?vue&type=style&index=0&id=098c31e4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__